import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RoboticMowerSitemapState } from '~/domain/native/models/mower-sitemap-state';

export const initialState: Fields = {
  mowerSitemapChangeRecords: [],
};

export interface Fields {
  mowerSitemapChangeRecords: RoboticMowerSitemapState[];
}

const reducer = createSlice({
  name: 'robotic-mower-webview-sitemaps-sync-state',
  initialState,
  reducers: {
    registerChangeTimestamp: (state, action: PayloadAction<RoboticMowerSitemapState>) => {
      state.mowerSitemapChangeRecords = [
        ...state.mowerSitemapChangeRecords.filter((item) => item.assetId !== action.payload.assetId),
        action.payload,
      ];
    },
    clearSitemapByIprId: (state, action: PayloadAction<string>) => {
      state.mowerSitemapChangeRecords = state.mowerSitemapChangeRecords.filter(
        (item) => item.assetId !== action.payload
      );
    },
  },
});

export const { registerChangeTimestamp, clearSitemapByIprId } = reducer.actions;

export default reducer.reducer;
